import { Chip, ChipProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

export const NewShopChip: React.FC<ChipProps> = ({ sx = {}, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { root } = theme.components?.[`NewShopChip`]?.styleOverrides || {}
  return <Chip label={t("New Shops")} sx={deepmerge(root, sx)} {...props} />
}
